<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل حي</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/neighborhoodview">الاحياء</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل حي</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="py-2 ms-2 text-brown">
              <i class="bi bi-pencil-square text-brown ps-2"></i> عرض البيانات
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="regionError" :alertMessage= "message" />
              </div>
              <div v-if="successRegion" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <label class="form-label" for="">المنطقة:</label>
                    <div>{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
                  </div>
                  <div class="col">
                    <label class="form-label" for="">المدينة:</label>
                    <div>{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col-12 col-sm-6">
                    <label class="form-label" for="">الاسم - عربي:</label>
                    <div>{{ dataRow.name }}</div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <label class="form-label" for="">الاسم - انجليزي:</label>
                    <div>{{ dataRow.nameEn }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">خط العرض (latitude):</label>
                    <div>{{ dataRow.latitude }}</div>
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">خط الطول (longitude):</label>
                    <div>{{ dataRow.longitude }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <img :src="BASE_URL+'uploads/'+coverimg" class="img-fluid" alt="">
                  </div>
                </div>
                <div class="row py-2">
                  <div class="col">
                    <label class="form-label" for="">الحاله:</label>
                    <div>{{ (dataRow.isActive)? 'نشط' : 'غير نشط' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'NeighborhoodRead',
  data(){
    return {
      neighborhoodID: this.$route.params.id,
      regionError: false,
      message: '',
      neighborhoodName: "",
      isLoading: false,
      successRegion: false,
      coverimg: "",
      loader: false,
      dataRow: {},
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    getData() {
      this.regionError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/neighborhoods/retrieve/${this.neighborhoodID}`).then(res => {
        this.dataRow = res.data.neighborhood;
        this.coverimg = res.data.neighborhood.cover;
        this.isLoading = false;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.regionError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
  },
  created() {
    this.getData();
    window.scroll(0,0);
  }
}
</script>